import { render, staticRenderFns } from "./AccountingBookYear.vue?vue&type=template&id=5fc3c7b3"
import script from "./AccountingBookYear.vue?vue&type=script&lang=ts"
export * from "./AccountingBookYear.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fc3c7b3')) {
      api.createRecord('5fc3c7b3', component.options)
    } else {
      api.reload('5fc3c7b3', component.options)
    }
    module.hot.accept("./AccountingBookYear.vue?vue&type=template&id=5fc3c7b3", function () {
      api.rerender('5fc3c7b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/AccountingBookYear.vue"
export default component.exports